import classNames from "classnames"
import React from "react"
import { SanityNextImg } from "../../../cms/components"
import Dot from "../../atoms/Dot"

interface ColorPreviewProps {
  colorValue?: string
  shadeUrl?: string
  noPadding?: boolean
  selected?: boolean
  size: string
  onClick?: () => void
}

const ColorPreview = ({
  colorValue,
  shadeUrl,
  selected,
  noPadding,
  size,
  onClick,
}: ColorPreviewProps) => {
  return (
    <div
      className={classNames("p-1", {
        "p-0": noPadding,
        flex: shadeUrl !== undefined,
      })}
      style={
        selected
          ? {
              borderRadius: "50%",
              border: `2px solid ${colorValue}`,
              padding: 0,
              margin: 0,
            }
          : undefined
      }
    >
      {!shadeUrl && colorValue && (
        <Dot
          onClick={onClick}
          size={size}
          colorValue={colorValue}
          backgroundImage={shadeUrl}
        />
      )}
      {shadeUrl && (
        <div
          style={{
            maxWidth: 50,
            maxHeight: 24,
            display: "block",
          }}
        >
          <SanityNextImg
            normalImgTag
            // height={24}
            // width={50}
            width={50}
            sizes="50px"
            asset={shadeUrl}
            style={{ maxHeight: 24 }}
          />
        </div>
      )}
    </div>
  )
}

ColorPreview.defaultProps = {
  size: "1.5rem",
}

export default ColorPreview
